module.exports = __webpack_public_path__ + "static/media/instazoom-logo-tr-white-30.edf7800a.png";